import { AdminLayoutWithAuth } from "@/components/layout/AdminLayout/AdminLayout";
import { LoginLayout } from "@/components/layout/LoginLayout/LoginLayout";
import AdminAuthCallback from "@/pages/auth/AdminAuthCallback";
import Login from "@/pages/auth/Login";
import Logout from "@/pages/auth/Logout";
import Recover from "@/pages/auth/Recover";
import RecoverComplete from "@/pages/auth/RecoverComplete";
import Register from "@/pages/auth/Register";
import ResetPassword from "@/pages/auth/ResetPassword";
import ResetPasswordComplete from "@/pages/auth/ResetPasswordComplete";
import Home from "@/pages/home/Home";
import MasterDataDetail from "@/pages/master-data/MasterDataDetail";
import MasterDataList from "@/pages/master-data/MasterDataList";
import PageNotFound from "@/pages/PageNotFound";
import ServerErrorPage from "@/pages/ServerErrorPage";
import { guestLoader } from "@/routes/authLoader";
import { AppRoutes } from "@/routes/config";
import { RouteObject } from "react-router-dom";
import { MatchLayout } from "@/features/match/layout/MatchLayout";
import CanceledContractList from "@/pages/match/CanceledContractList";
import TrialCancelledList from "@/pages/match/TrialCancelledList";
import TrialMatchList from "@/pages/match/TrialMatchList";
import DuringContractList from "@/pages/match/DuringContractList";
import MatchDetail from "@/pages/match/MatchDetail";
import MatchEdit from "@/pages/match/MatchEdit";
import MatchCreate from "@/pages/match/MatchCreate";
import { ContactLayout } from "@/features/contact-type/layout/ContactLayout";
import UnresolvedContactList from "@/pages/contact/UnresolvedContactList";
import ResolvedContactList from "@/pages/contact/ResolvedContactList";
import ContactDetail from "@/pages/contact/ContactDetail";
import ContactType from "@/pages/contact-type/ContactType";
import ContactTypeCreate from "@/pages/contact-type/ContactTypeCreate";
import ContactTypeEdit from "@/pages/contact-type/ContactTypeEdit";
import { SettingLayout } from "@/features/system-setting/layout/SettingLayout";
import EmailSetting from "@/pages/system-setting/EmailSetting";
import MaintenanceSetting from "@/pages/system-setting/MaintenanceSetting";
import Information from "@/pages/information/Information";
import InformationCreate from "@/pages/information/InformationCreate";
import InformationEdit from "@/pages/information/InformationEdit";
import Chat from "@/pages/chat/Chat";

export const routes: RouteObject[] = [
  {
    element: <LoginLayout />,
    children: [
      { path: AppRoutes.recover, element: <Recover />, loader: guestLoader },
      {
        path: AppRoutes.recoverComplete,
        element: <RecoverComplete />,
      },
      { path: AppRoutes.resetPassword, element: <ResetPassword /> },
      {
        path: AppRoutes.resetPasswordComplete,
        element: <ResetPasswordComplete />,
      },
      { path: AppRoutes.login, element: <Login />, loader: guestLoader },
      { path: AppRoutes.register, element: <Register /> },
      { path: AppRoutes.adminAuthCallback, element: <AdminAuthCallback /> },
    ],
  },
  {
    element: <AdminLayoutWithAuth enableHeader={false} enableSidebar={false} />,
    children: [
      {
        path: AppRoutes.matchCreate,
        element: <MatchCreate />,
      },
    ],
  },
  {
    element: <AdminLayoutWithAuth />,
    children: [
      {
        path: AppRoutes.home,
        element: <Home />,
      },
      {
        // path: AppRoutes.match,
        element: <MatchLayout />,
        children: [
          { path: AppRoutes.duringContractList, element: <DuringContractList /> },
          { path: AppRoutes.canceledContractList, element: <CanceledContractList /> },
          { path: AppRoutes.trialMatchList, element: <TrialMatchList /> },
          { path: AppRoutes.trialCancelledList, element: <TrialCancelledList /> },
        ],
      },
      { path: AppRoutes.matchDetail, element: <MatchDetail /> },
      { path: AppRoutes.matchEdit, element: <MatchEdit /> },

      { path: AppRoutes.information, element: <Information /> },
      { path: AppRoutes.informationCreate, element: <InformationCreate /> },
      { path: AppRoutes.informationEdit, element: <InformationEdit /> },

      {
        element: <ContactLayout />,
        children: [
          { path: AppRoutes.unresolvedContact, element: <UnresolvedContactList /> },
          { path: AppRoutes.resolvedContact, element: <ResolvedContactList /> },
          { path: AppRoutes.unresolvedContactDetail, element: <ContactDetail /> },
          { path: AppRoutes.resolvedContactDetail, element: <ContactDetail /> },
          { path: AppRoutes.contactType, element: <ContactType /> },
          { path: AppRoutes.contactTypeCreate, element: <ContactTypeCreate /> },
          { path: AppRoutes.contactTypeEdit, element: <ContactTypeEdit /> },
        ],
      },
      { path: AppRoutes.chat, element: <Chat /> },
      { path: AppRoutes.chatDetail, element: <Chat /> },
      {
        element: <SettingLayout />,
        children: [
          { path: AppRoutes.emailSetting, element: <EmailSetting /> },
          { path: AppRoutes.maintenanceSetting, element: <MaintenanceSetting /> },
        ],
      },

      { path: AppRoutes.masterData, element: <MasterDataList /> },
      { path: AppRoutes.masterDataDetail, element: <MasterDataDetail /> },
    ],
  },
  { path: AppRoutes.logout, element: <Logout /> },
  { path: AppRoutes.serverErrorPage, element: <ServerErrorPage /> },
  { path: "*", element: <PageNotFound /> },
];
